'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useState } from 'react';
import type { LabsSubject } from '../../types';

/**
 * SubjectLogo — the round avatar for the entity the learner analyses: the M4 selection cards
 * (Figma 40:9630) and the M4 activity header. Renders the subject's real brand SVG from `public/`
 * (`subject.logo`) on a white circle; if the asset fails to load — or the pack left `logo` empty —
 * it falls back to the subject monogram on its accent color (the prototype's `onerror`
 * monogram-chip behaviour).
 *
 * fs-* native chrome (round pill, fs-border) with the per-subject accent reserved for the fallback
 * only — the SVGs carry their own brand color, so the resting state is a neutral white chip.
 */
export function SubjectLogo(t0) {
  const $ = _c(17);
  const {
    subject,
    size: t1
  } = t0;
  const size = t1 === undefined ? 40 : t1;
  const [errored, setErrored] = useState(false);
  if (errored || !subject.logo) {
    const t2 = size * 0.4;
    let t3;
    if ($[0] !== size || $[1] !== subject.accent || $[2] !== t2) {
      t3 = {
        width: size,
        height: size,
        backgroundColor: subject.accent,
        fontSize: t2
      };
      $[0] = size;
      $[1] = subject.accent;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== subject.monogram || $[5] !== t3) {
      t4 = <span aria-hidden={true} className="flex shrink-0 items-center justify-center rounded-fs-pill font-medium text-white" style={t3}>{subject.monogram}</span>;
      $[4] = subject.monogram;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t2;
  if ($[7] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[7] = size;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = `${subject.name} logo`;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setErrored(true);
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== size || $[11] !== subject.logo || $[12] !== t3) {
    t5 = <img alt={t3} className="h-full w-full object-contain p-1" height={size} onError={t4} src={subject.logo} width={size} />;
    $[10] = size;
    $[11] = subject.logo;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t5) {
    t6 = <span className="flex shrink-0 items-center justify-center overflow-hidden rounded-fs-pill border border-fs-border bg-fs-surface" style={t2}>{t5}</span>;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}